import { Dropdown, DropDownProps } from 'antd';
import classNames from 'classnames';

const MDropdown: React.FC<DropDownProps> = (props) => {
  return (
    <Dropdown
      {...(props as DropDownProps)}
      overlayClassName={classNames('trojan-dropdown', props.className)}
    />
  );
};

export default MDropdown;
